import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=7da39aa4&"
import script from "./DropArea.vue?vue&type=script&lang=ts&"
export * from "./DropArea.vue?vue&type=script&lang=ts&"
import style0 from "./DropArea.vue?vue&type=style&index=0&id=7da39aa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports